/**
 * Countdown para announcement-bar.
 * Busca [data-announcement-countdown] y actualiza días/horas/minutos/segundos.
 */
(function () {
  'use strict';

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function parseEndDate(settings) {
    const year = settings.year;
    const month = settings.month;
    const day = settings.day;
    const hour = String(settings.hour).padStart(2, '0');
    const minute = String(settings.minute).padStart(2, '0');
    const timezoneString =
      settings.timeZoneSelection === 'shop' && settings.shopTimezone
        ? ' GMT' + settings.shopTimezone
        : '';

    return new Date(
      Date.parse(month + ' ' + day + ', ' + year + ' ' + hour + ':' + minute + timezoneString)
    );
  }

  function initTimer(el) {
    const settingsEl = el.querySelector('[data-timer-settings]');
    if (!settingsEl) return;

    let settings;
    try {
      settings = JSON.parse(settingsEl.textContent);
    } catch (e) {
      return;
    }

    const end = parseEndDate(settings);
    if (isNaN(end.getTime())) return;

    const endTime = end.getTime();
    const daysEl = el.querySelector('[data-days]');
    const hoursEl = el.querySelector('[data-hours]');
    const minutesEl = el.querySelector('[data-minutes]');
    const secondsEl = el.querySelector('[data-seconds]');

    function tick() {
      const distance = endTime - Date.now();

      if (distance < 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        el.classList.add('is-complete');
        if (settings.hideTimerOnComplete) {
          el.classList.add('is-hidden');
        }
        clearInterval(interval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      el.classList.add('is-active');
    }

    tick();
    const interval = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-announcement-countdown]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-announcement-countdown]').forEach(initTimer);
  });
})();
